export default class EvidenceLinksCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
  // constants
    var linksVm = this
    const sharedVariable = PortfolioModalSrv.getVariable()
    linksVm.evidence     = sharedVariable.evidence
    linksVm.filetypes = GlobalConfig.portfolioConfig.fileTypes

  // methods
    linksVm.close = close

    function close () {
      return $mdDialog.hide()
    }  

  }
}

EvidenceLinksCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/evidenceLinksCtrl.js